import { Flex, Text } from '@servicetitan/anvil2';
import { FC, ReactNode } from 'react';

interface NoAccessMessageProps {
    /** The caller's root org name from the access gate's 403, or null to say "your organization". */
    orgName: string | null;
    /** Extra actions under the message (the standalone Shell adds Sign out). */
    children?: ReactNode;
}

/*
 * Shown when the Org Hub access gate (OrgHub.IsEnabled) denies the signed-in caller — by the standalone
 * Shell's no-access screen and by the embedded OrgHub in place of an empty registry.
 */
export const NoAccessMessage: FC<NoAccessMessageProps> = ({ orgName, children }) => (
    <Flex direction="column" gap="3" data-testid="org-hub-no-access-message">
        <Text variant="headline" el="h1" size="medium">
            You don&apos;t have access to Org Hub
        </Text>
        <Text data-testid="no-access-message">
            Org Hub isn&apos;t enabled for{' '}
            {orgName ? <strong>{orgName}</strong> : 'your organization'} yet.
        </Text>
        <Text>Contact your ServiceTitan administrator if you think this is a mistake.</Text>
        {children}
    </Flex>
);
